<app-cookie-consent></app-cookie-consent>
<div class="registration">
  <app-login-header></app-login-header>
  <div *ngIf="!typeOfCustomer">
    <div class="container text-center">
      <div class="select-category">Select your Category</div>
      <div class="select-option">Select an option to continue</div>
      <div class="row new-existing">
        <div class="col-6 option option-new" (click)="setCategory(1)">
          <div>
            <svg width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" width="38" height="38" rx="12" fill="#00423E" fill-opacity="0.1"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 18C17.7091 18 19.5 16.2091 19.5 14C19.5 11.7909 17.7091 10 15.5 10C13.2909 10 11.5 11.7909 11.5 14C11.5 16.2091 13.2909 18 15.5 18ZM15.5 16C16.6046 16 17.5 15.1046 17.5 14C17.5 12.8954 16.6046 12 15.5 12C14.3954 12 13.5 12.8954 13.5 14C13.5 15.1046 14.3954 16 15.5 16ZM18.5 21C19.0523 21 19.5 21.4477 19.5 22V28H21.5V22C21.5 20.3431 20.1569 19 18.5 19H12.5C10.8432 19 9.5 20.3431 9.5 22V28H11.5V22C11.5 21.4477 11.9477 21 12.5 21H18.5ZM27.5 14H25.5V16H23.5V18H25.5V20H27.5V18H29.5V16H27.5V14Z" fill="#171717"/>
            </svg>
          </div>
          New Customer
        </div>
        <div class="col-6 option option-existing" (click)="setCategory(2)"> 
          <div>
            <svg width="39" height="38" viewBox="0 0 39 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" width="38" height="38" rx="12" fill="#8F92A1" fill-opacity="0.1"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 14C23.5 16.2091 21.7091 18 19.5 18C17.2909 18 15.5 16.2091 15.5 14C15.5 11.7909 17.2909 10 19.5 10C21.7091 10 23.5 11.7909 23.5 14ZM21.5 14C21.5 15.1046 20.6046 16 19.5 16C18.3954 16 17.5 15.1046 17.5 14C17.5 12.8954 18.3954 12 19.5 12C20.6046 12 21.5 12.8954 21.5 14Z" fill="#171717"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 22C23.5 21.4477 23.0523 21 22.5 21H16.5C15.9477 21 15.5 21.4477 15.5 22V28H13.5V22C13.5 20.3431 14.8432 19 16.5 19H22.5C24.1569 19 25.5 20.3431 25.5 22V28H23.5V22Z" fill="#171717"/>
            </svg>
          </div>
          Existing Customer
        </div>
      </div>
      <div class="help text-size" *ngIf="utility">
        Already have an account?
        <a class="link" [routerLink]="['/new-connection/' + utility.name + '/login']">Log in</a>
      </div>
    </div>
  </div>
  <div *ngIf="typeOfCustomer">
    <div class="register-container">
    
      <div class="register-page">
        <div class="page-wrap">
          <div class="form-wrapper">
            <h1>Create a new account</h1>
    
            <div class="info row">
              <div class="col-3">
                <svg
                  class="icon-bg"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                  stroke-linejoin="round"
                  stroke-miterlimit="2"
                  height="32"
                  width="32"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm0 6.5c-.414 0-.75.336-.75.75v5.5c0 .414.336.75.75.75s.75-.336.75-.75v-5.5c0-.414-.336-.75-.75-.75zm-.002-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
                    fill-rule="nonzero"
                  />
                </svg>
              </div>
              <span class="col-8"
                >Complete the fields below to create your security credentials which
                will be required for subsequent login.</span
              >
            </div>
            <form ngNativeVAlidate (submit)="register()">
              <div *ngIf="typeOfCustomer == 2">
                <div class="form-item" style="position: relative">
                  <label for="floatingInput">Account Number/Meter Number <span class="red">*</span></label>
                  <input
                    [ngClass]="{ invalidAcc: invalidAccNo == true }"
                    name="accountNumber"
                    type="text"
                    class="form-control"
                    id="floatingInput"
                    placeholder="Account Number / Meter Number"
                    [(ngModel)]="accountNumber"
                    (blur)="checkAccountOrMeterNumber()"
                  />
                  <div class="check-approved">
                    <ng-template [ngIf]="validAccNo">
                      <img
                        alt="Check icon"
                        width="22"
                        height="22"
                        src="../../../assets/icons/check-circle.svg"
                      />
                    </ng-template>
                  </div>
                </div>
                <ng-template [ngIf]="invalidAccNo">
                  <div>
                    <span class="invalid-text">This account doesn't exist.</span>
                  </div>
                </ng-template>
      
                <ng-template [ngIf]="validAccNo">
                  <div class="validAcc">
                    <span class="text"> Customer Name</span>
                    <br />
                    <span class="customer-name">{{ customerName }}</span>
                  </div>
                </ng-template>
              </div>
              <div class="form-item">
                <label for="floatingInput">Email <span class="red">*</span> </label>
                <input
                  name="email"
                  type="text"
                  class="form-control"
                  id="floatingInput"
                  placeholder="Email"
                  [(ngModel)]="email"
                  required
                />
              </div>
              <div class="form-item" style="display: block !important">
                <label for="floatingInput">Phone Number <span class="red">*</span></label>
                <br />
                <input
                  id="floatingInput"
                  type="tel"
                  class="form-control"
                  (blur)="onBlur()"
                  (keypress)="onInputKeyPress($event)"
                  [(ngModel)]="phoneNumber"
                  #telInput
                  name="tellInput"
                />
              </div>
              <div class="form-item" style="position: relative">
                <label for="floatingPassword">Password <span class="red">*</span></label>
                <input
                  [(ngModel)]="pass"
                  name="password"
                  [type]="showPw ? 'text' : 'password'"
                  class="form-control"
                  id="floatingPassword"
                  placeholder="Password"
                  required
                />
                <div class="show-pw" (click)="showPassword()">
                  <ng-template [ngIf]="showPw">
                    <img
                      src="../../../assets/icons/eye.svg"
                      alt="Show password icon"
                    />
                  </ng-template>
                  <ng-template [ngIf]="!showPw">
                    <img
                      src="../../../assets/icons/eye-slash.svg"
                      alt="Show password icon"
                    />
                  </ng-template>
                </div>
                <app-password-strength
                  [passwordToCheck]="pass"
                  (passwordStrength)="onPasswordStrengthChanged($event)"
                ></app-password-strength>
              </div>
              <button class="btn btn-dark text-size" type="submit">Create an account</button>
            </form>
            <div class="help text-size">
              Already have an account?
              <a class="link" [routerLink]="['/new-connection/' + utility.name + '/login']">Log in</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<button type="button" #openOtpModal hidden data-bs-toggle="modal" data-bs-target="#otpVerification"></button>
<button type="button" #openRegisterSuccessModal hidden data-bs-toggle="modal" data-bs-target="#registerSuccess"></button>

<div class="modal fade" id="otpVerification" tabindex="-1" aria-labelledby="otpVerificationTitle" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered otp-dialog">
    <div class="modal-content otp-modal-content">
      <div class="otp-body">
        <h2 class="otp-title">OTP Verification</h2>

        <div class="otp-info-box">
          <div class="otp-info-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z" fill="#888"/>
            </svg>
          </div>
          <div class="otp-info-text">
            Please enter the 4-digit verification code sent to {{ maskedEmail }}
          </div>
        </div>

        <div class="otp-input-section">
          <label class="otp-label">Enter OTP</label>
          <div class="otp-digits" [class.otp-digits-error]="otpError">
            <input #otpInput0 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[0]" (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)" (paste)="onOtpPaste($event)" />
            <input #otpInput1 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[1]" (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" (paste)="onOtpPaste($event)" />
            <input #otpInput2 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[2]" (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" (paste)="onOtpPaste($event)" />
            <input #otpInput3 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[3]" (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" (paste)="onOtpPaste($event)" />
          </div>
        </div>

        <div class="otp-resend-row" *ngIf="!otpError">
          <ng-container *ngIf="resendCooldown > 0">
            Didn't receive code? Resend code in <span class="otp-timer">{{ resendCooldown }}s</span>
          </ng-container>
          <ng-container *ngIf="resendCooldown === 0">
            Didn't receive code? Click <a class="otp-resend-link" (click)="resendOtp()">here</a> to resend another code
          </ng-container>
        </div>

        <div class="otp-error-row" *ngIf="otpError && otpExpired">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
          </svg>
          <span>{{ otpError }} Click <a class="otp-resend-link" (click)="resendOtp()">here</a> to resend another code</span>
        </div>

        <div class="otp-error-row" *ngIf="otpError && !otpExpired">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
          </svg>
          <span>{{ otpError }}</span>
        </div>

        <button class="btn otp-continue-btn" (click)="verifyOtp()" [disabled]="otpLoading">
          {{ otpLoading ? 'Verifying...' : 'Continue' }}
        </button>
      </div>
      <button type="button" #closeOtpModal hidden data-bs-dismiss="modal"></button>
    </div>
  </div>
</div>

<div class="modal fade" id="registerSuccess" tabindex="-1" aria-labelledby="registerSuccessTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content success-modal-content">
      <div class="modal-header close-reg-modal">
        <div class="header-x" #closeModal data-bs-dismiss="modal" aria-label="Close" (click)="closeSuccessfullRegistrationModal()">
          <img src="../../../assets/solid.svg" alt="" />
        </div>
      </div>
      <div class="content text-center success-content">
        <div class="success-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="#21935C"/>
          </svg>
        </div>
        <div class="success-title">OTP verification successfully</div>
        <div class="success-subtitle">Your account has been confirmed</div>
        <div class="proceed-div">
          <button class="btn success-btn" (click)="proceedToLogin()">Proceed to Login</button>
        </div>
      </div>
    </div>
  </div>
</div>
